import { render, staticRenderFns } from "./GenericXConfiguration.vue?vue&type=template&id=b97e828c&scoped=true&"
import script from "./GenericXConfiguration.vue?vue&type=script&lang=js&"
export * from "./GenericXConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GenericXConfiguration.vue?vue&type=style&index=0&id=b97e828c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97e828c",
  null
  
)

export default component.exports